import { h } from 'vue'
import MoleculeTextImage from '~/components/molecules/text-image/text-image.vue'
import MoleculeTextVideo from '~/components/molecules/text-video/text-video.vue'
import OrganismRichText from '~/components/organisms/rich-text/rich-text.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(
    UiComponentWrapper,
    {
      class: [
        'benefit',
        `text-${props.record.color}`,
        props.record.backgroundColor
          ? `background-${props.record.color}`
          : 'background-livestorm-blue',
      ],
    },
    () => [
      h(UiComponentContainer, {}, () => [
        !props.record?.asset?.video
        && h(MoleculeTextImage, {
          button: {
            action: props.page.ctaCustom
              ? undefined
              : props.callToAction.action,
            label: 'Benefits section CTA',
            slot: props.page.ctaCustom?.slot || props.callToAction.slot,
            to: props.page.ctaCustom?.slug || props.callToAction.to,
          },
          direction: props.record.imagePosition.toLowerCase(),
          image: {
            alt: props.record.asset?.alt,
            height: props.record.asset?.height,
            url: props.record.asset?.url,
            width: props.record.asset?.width,
          },
          level: 3,
          node: {
            component: OrganismRichText,
            properties: {
              class: 'description whitespace-normal',
              content: [
                {
                  __typename: 'ContentTextHtmlRecord',
                  text: props.record.text,
                },
              ],
            },
          },
          ['onPrimary:click']: () => {
            props.callToAction.onClick()
          },
        }, {
          heading: () => props.record.title,
        }),
        props.record?.asset?.video
        && h(MoleculeTextVideo, {
          button: {
            action: props.page.ctaCustom
              ? undefined
              : props.callToAction.action,
            label: 'Benefits section CTA',
            slot: props.page.ctaCustom?.slot || props.callToAction.slot,
            to: props.page.ctaCustom?.slug || props.callToAction.to,
          },
          direction: props.record.imagePosition.toLowerCase(),
          level: 3,
          node: {
            component: OrganismRichText,
            properties: {
              class: 'description whitespace-normal',
              content: [
                {
                  __typename: 'ContentTextHtmlRecord',
                  text: props.record.text,
                },
              ],
            },
          },
          video: {
            autoplay: true,
            loop: true,
            muted: true,
            url: props.record.asset?.video?.mp4Url,
            width: props.record.asset?.width,
            height: props.record.asset?.height,
          },
          ['onPrimary:click']: () => {
            props.callToAction.onClick()
          },
        }, {
          heading: () => props.record.title,
        }),
      ]),
    ],
  )
}

Functional.props = {
  callToAction: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  page: {
    required: true,
    type: Object,
  },
}

export default Functional
